export enum ClinicalRecordType
{
    ALL = 'all',
    SYMPTOM = 'symptom',
    APPOINTMENT = 'appointment',
    EXAM_OR_ANALYSIS = 'exam-or-analysis',
    HOSPITALIZATION = 'hospitalization',
    MEDICATION = 'medication',
    OTHER = 'other'
}
